import { Box } from '@mui/material';
import { useStyles } from './styles';
import { DateObject } from '@uplift/services';
import { grey } from '@mui/material/colors';
import { Timeslot } from './types';
import { Button } from '../Button';
import { useScheduler } from './hook/use-scheduler.hook';
import { StandardTimezoneSelect } from '../UserTimezoneSelect';

export type SchedulerProps = {
  hideTimezoneSelect?: boolean;
  disableTimezoneSelect?: boolean;
  dateDisplayOnly?: boolean;
  timeslots: Timeslot[];
  daysAheadLimit?: number;
  dayParting?: boolean;
  isTriad?: boolean;
  withDatePicker?: boolean;
  onScheduleSession?: (selectedSlot: DateObject) => (Promise<void> | void);
  initialSelectedSlot?: DateObject;
  onDisabledForwardClick?: () => void;
  classes?: Partial<{
    datePickerContainer?: string;
  }>;
};

export const Scheduler: React.VFC<SchedulerProps> = props => {
  const { classes } = useStyles(undefined, { props: { classes: props.classes } });
  const { selectDate, timeslots, timezoneSelect, datePicker, onScheduleSessionClick } = useScheduler(props);

  const scheduler = (
    <Box display="flex" flexDirection="column" gap={props.isTriad ? 0 : '0.5rem'}>
      {selectDate}
      {timeslots}
      {timezoneSelect}
    </Box>
  );

  if (datePicker) {
    return (
      <Box display="flex" border={`1px solid ${grey[300]}`} borderRadius="4px" className={classes.datePickerContainer}>
        <Box width="282px" p={2}>
          {datePicker}
          <Box textAlign="center" mt={2}>
            <StandardTimezoneSelect />
          </Box>
        </Box>
        <Box className={classes.backgroundGrey} px={2} pt={3} pb={2} flex={1}>
          {scheduler}
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      {scheduler}
      {props.isTriad && (
        <Box mt={2} px={1}>
          <Button
            variant="contained"
            fullWidth
            color="secondary"
            onClick={onScheduleSessionClick}
          >
            Schedule Session
          </Button>
        </Box>
      )}
    </Box>
  );
};
